import { DateFormat, getKeyFromObj } from "../../../config/helper";
import { TAB_KEYS } from "./user-management";

export const USER_TABLE = [
  {
    id: "name",
    headerKey: "USER_MANAGEMENT.LIST.NAME",
    headerValue: function (t) {
      return getHeaderValue(t, this.headerKey);
    },
    apiKey: "name",
    dataValue: function (user) {
      return getDataValue(user, this.apiKey);
    },
    isForTab: [TAB_KEYS.ALL, TAB_KEYS.INACTIVE],
  },
  {
    id: "email",
    headerKey: "USER_MANAGEMENT.LIST.EMAIL",
    headerValue: function (t) {
      return getHeaderValue(t, this.headerKey);
    },
    apiKey: "email",
    dataValue: function (user) {
      return getDataValue(user, this.apiKey);
    },
    isForTab: [TAB_KEYS.ALL, TAB_KEYS.INACTIVE],
  },
  {
    id: "created_date",
    headerKey: "USER_MANAGEMENT.LIST.CREATED_DATE",
    headerValue: function (t) {
      return getHeaderValue(t, this.headerKey);
    },
    apiKey: "created_at",
    dataValue: function (user) {
      return getDataValue(user, this.apiKey);
    },
    isForTab: [TAB_KEYS.ALL],
  },
  {
    id: "created_by",
    headerKey: "USER_MANAGEMENT.LIST.CREATED_BY",
    headerValue: function (t) {
      return getHeaderValue(t, this.headerKey);
    },
    apiKey: "created_by_user.name",
    dataValue: function (user) {
      return getDataValue(user, this.apiKey);
    },
    isForTab: [TAB_KEYS.ALL],
  },
  {
    id: "inactive_by",
    headerKey: "USER_MANAGEMENT.LIST.INACTIVE_BY",
    headerValue: function (t) {
      return getHeaderValue(t, this.headerKey);
    },
    apiKey: "updated_by_user.name",
    dataValue: function (user) {
      return getDataValue(user, this.apiKey);
    },
    isForTab: [TAB_KEYS.INACTIVE],
  },
  {
    id: "inactive_date",
    headerKey: "USER_MANAGEMENT.LIST.INACTIVE_DATE",
    headerValue: function (t) {
      return getHeaderValue(t, this.headerKey);
    },
    apiKey: "updated_at",
    dataValue: function (user) {
      return getDataValue(user, this.apiKey);
    },
    isForTab: [TAB_KEYS.INACTIVE],
  },
  {
    id: "actions",
    headerKey: "USER_MANAGEMENT.LIST.ACTIONS",
    headerValue: function (t) {
      return getHeaderValue(t, this.headerKey);
    },
    apiKey: null,
    dataValue: function (user, handleDeleteClick, handleEditClick) {
      return getDataValue(
        user,
        this.apiKey,
        this,
        handleDeleteClick,
        handleEditClick
      );
    },
    isForTab: [TAB_KEYS.ALL],
  },
];

const DATE_FIELD_API_KEYS = ["created_at", "updated_at"];

function getHeaderValue(t, key) {
  return t(key);
}

function getDataValue(user, key, item, handleDeleteClick, handleEditClick) {
  if (item && ["actions"].includes(item.id)) {
    return (
      <ul className="action-btn">
        <li>
          <a
            href="#!"
            className="btn btn-default"
            onClick={() => handleEditClick(user)}
          >
            <i className="ic-edit"></i>
          </a>
        </li>
        <li>
          <a
            href="#!"
            className="btn btn-default"
            onClick={() => handleDeleteClick(user)}
          >
            <i className="ic-delete"></i>
          </a>
        </li>
      </ul>
    );
  }
  if (DATE_FIELD_API_KEYS.includes(key)) {
    return DateFormat(new Date(user[key]));
  }
  return getKeyFromObj(user, key, "-");
}
